import React from 'react';

import { EffectiveMarginPositionResult, EffectiveMarginTotals } from '@/types/effectiveMargin';

import EffectiveMarginFallbackGroup from './EffectiveMarginFallbackGroup';


interface EffectiveMarginStrategyBreakdownProps {
  results: EffectiveMarginPositionResult[];
  totals: EffectiveMarginTotals;
}

const EffectiveMarginStrategyBreakdown: React.FC<EffectiveMarginStrategyBreakdownProps> = ({
  results,
  totals,
}) => (
  <section role="region" aria-label="Strategy breakdown" className="mt-5">
    <div className="mb-3 flex items-end justify-between gap-4">
      <div>
        <h3 className="m-0 font-serif text-[18px] font-normal">Strategy breakdown</h3>
        <p className="mb-0 mt-1 text-[10.5px] text-[#666]">
          Expand a row to see its business rationale, methodology, and exact combined inputs.
        </p>
      </div>
      <div className="text-[10px] text-[#666]">No recognised strategies</div>
    </div>

    {results.length > 0 ? (
      <EffectiveMarginFallbackGroup results={results} totals={totals} />
    ) : (
      <div className="border border-black/10 px-5 py-7 text-center text-[12px] text-[#666]">
        No source positions were returned for this snapshot.
      </div>
    )}
  </section>
);

export default EffectiveMarginStrategyBreakdown;
